import { render } from "./file-shares.vue?vue&type=template&id=5ce6ea2f&lang=pug"
import script from "./file-shares.vue?vue&type=script&lang=js"
export * from "./file-shares.vue?vue&type=script&lang=js"

import "./file-shares.vue?vue&type=style&index=0&id=5ce6ea2f&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__